const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsDevOpsProfessional = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Operating Production-Grade Systems on AWS
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          With the AWS Certified DevOps Engineer – Professional certification, I design,
          automate, and operate reliable cloud systems with a strong focus on scalability,
          resilience, and continuous delivery.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/awsDevOpsEngineerBadge.png"
          alt="AWS Certified DevOps Engineer Professional"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified DevOps Engineer – Professional
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification reflects deep expertise in building automated deployment pipelines,
          managing infrastructure as code, and ensuring operational excellence in cloud systems.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          More importantly, it represents a practical approach — designing systems that can be deployed,
          monitored, and maintained reliably in real-world environments.
        </p>
      </div>


      {/* CAPABILITIES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          DevOps Capabilities I Can Deliver
        </h2>

        <div style={gridStyle}>
          {[
            "Designing and implementing end-to-end CI/CD pipelines",
            "Automating infrastructure using AWS SAM and CloudFormation",
            "Building deployment workflows with rollback and validation mechanisms",
            "Implementing monitoring, logging, and alerting systems",
            "Designing highly available and fault-tolerant architectures",
            "Optimizing deployment processes for speed and reliability",
            "Integrating security practices into CI/CD pipelines",
            "Managing environments across development, staging, and production",
            "Ensuring system reliability through observability and automation"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* USE CASES 🔥 */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          Where This Creates Real Value
        </h2>

        <div style={gridStyle}>
          {[
            "Automating software delivery pipelines",
            "Reducing deployment risks and downtime",
            "Improving system reliability and uptime",
            "Enabling faster and safer feature releases",
            "Standardizing infrastructure and environments",
            "Supporting scalable and growing systems"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* DEPLOYMENT MATURITY 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Production-Ready Deployment Approach
        </h2>

        <div style={gridStyle}>
          {[
            "Blue/green and canary deployment strategies",
            "Automated rollback and failure recovery",
            "Environment isolation and configuration management",
            "Continuous testing and validation in pipelines",
            "Monitoring-driven feedback loops",
            "Cost-aware infrastructure and deployment decisions"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          DevOps is not just about automation — it’s about creating systems that can evolve safely,
          scale efficiently, and remain reliable under real-world conditions.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          I apply DevOps principles as an integral part of system design, not as an afterthought.
        </p>
      </div>


      {/* CTA 🔥 */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Improve Your Deployment and Operations
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s design reliable, automated, and scalable DevOps processes for your AWS systems.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Discuss Your DevOps Setup →
        </a>
      </div>

    </div>
  );
};

export default AwsDevOpsProfessional;